/** Stable id for @dnd-kit sortable row (bilge block in dashboard editor). */
export const BILGE_LAYOUT_SORT_ID = '__bilge_monitor_layout__';

/** 0 = before first section; N = after last section (N = section count) */
export function clampBilgeInsertIndex(raw, sectionCount) {
  let n = raw == null || raw === '' ? 0 : Number(raw);
  if (!Number.isFinite(n)) n = 0;
  return Math.max(0, Math.min(sectionCount, Math.floor(n)));
}

/**
 * Flat list of sortable ids for the editor: bilge slot + section ids in visual order.
 */
export function buildLayoutSortIds(sections, insertIndexRaw) {
  const list = Array.isArray(sections) ? sections : [];
  const n = list.length;
  const idx = clampBilgeInsertIndex(insertIndexRaw, n);
  const ids = [];
  for (let i = 0; i < n; i++) {
    if (idx === i) ids.push(BILGE_LAYOUT_SORT_ID);
    ids.push(list[i].id);
  }
  if (idx >= n) ids.push(BILGE_LAYOUT_SORT_ID);
  return ids;
}
